import { Controller } from "stimulus";

export default class VoteComponent extends Controller {
  connect() {
    this.inFlight = false;
    this.updateUI();
  }

  preventPropagation(event) {
    event.stopPropagation();
  }

  async upvote(event) {
    event.preventDefault();
    event.stopPropagation();

    const newScore = this.userVoteValue === 1 ? 0 : 1;
    await this.vote(newScore);
  }

  async downvote(event) {
    event.preventDefault();
    event.stopPropagation();

    const newScore = this.userVoteValue === -1 ? 0 : -1;
    await this.vote(newScore);
  }

  async vote(newScore) {
    if (this.inFlight) return;

    const previousState = {
      userVote: this.userVoteValue,
      score: this.scoreValue,
    };

    this.inFlight = true;
    this.setButtonsDisabled(true);

    // Calculate score change based on previous and new vote
    const previousVote = this.userVoteValue || 0; // Treat 0, null, NaN as no vote

    if (previousVote === 1 && newScore === 0) {
      // Remove upvote: -1
      this.scoreValue--;
    } else if (previousVote === 1 && newScore === -1) {
      // Change upvote to downvote: -2
      this.scoreValue -= 2;
    } else if (previousVote === -1 && newScore === 0) {
      // Remove downvote: +1
      this.scoreValue++;
    } else if (previousVote === -1 && newScore === 1) {
      // Change downvote to upvote: +2
      this.scoreValue += 2;
    } else if (previousVote === 0 && newScore === 1) {
      // New upvote: +1
      this.scoreValue++;
    } else if (previousVote === 0 && newScore === -1) {
      // New downvote: -1
      this.scoreValue--;
    }

    this.userVoteValue = newScore;
    this.updateUI();

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.getCsrfToken(),
        },
        credentials: "same-origin",
        body: JSON.stringify({ score: newScore }),
      });

      if (!response.ok) {
        throw new Error("Failed to vote");
      }

      this.inFlight = false;
      this.setButtonsDisabled(false);
    } catch (error) {
      // Rollback optimistic UI to previous state
      this.userVoteValue = previousState.userVote;
      this.scoreValue = previousState.score;
      this.updateUI();

      this.inFlight = false;
      this.setButtonsDisabled(false);
    }
  }

  setButtonsDisabled(disabled) {
    this.upvoteButtonTarget.disabled = disabled;
    this.downvoteButtonTarget.disabled = disabled;
  }

  updateUI() {
    this.scoreTarget.textContent = this.scoreValue;

    if (this.userVoteValue === 1) {
      this.upvoteButtonTarget.classList.add("text-red-500");
      this.upvoteButtonTarget.classList.remove("hover:text-red-500");
    } else {
      this.upvoteButtonTarget.classList.remove("text-red-500");
      this.upvoteButtonTarget.classList.add("hover:text-red-500");
    }

    if (this.userVoteValue === -1) {
      this.downvoteButtonTarget.classList.add("text-purple-600");
      this.downvoteButtonTarget.classList.remove("hover:text-purple-600");
    } else {
      this.downvoteButtonTarget.classList.remove("text-purple-600");
      this.downvoteButtonTarget.classList.add("hover:text-purple-600");
    }
  }

  getCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    return token ? token.content : "";
  }
}

VoteComponent.targets = ["upvoteButton", "downvoteButton", "score"];
VoteComponent.values = {
  votableId: String,
  votableType: String,
  userVote: Number,
  score: Number,
  url: String,
};
